import { useState } from 'react';
import ModalLotacoesPessoa from '../modals/ModalLotacoesPessoa';

type TipoPessoa = 'defensor' | 'colaborador' | 'estagiario';

interface BotaoLotacoesProps {
  tipoPessoa: TipoPessoa;
  pessoaId: number;
  pessoaNome: string;
}

export default function BotaoLotacoes({
  tipoPessoa,
  pessoaId,
  pessoaNome,
}: BotaoLotacoesProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-link link-secondary p-0"
        onClick={() => setShowModal(true)}
      >
        Visualizar
      </button>
      {showModal && (
        <ModalLotacoesPessoa
          show={showModal}
          handleHide={() => setShowModal(false)}
          tipoPessoa={tipoPessoa}
          pessoaId={pessoaId}
          pessoaNome={pessoaNome}
        />
      )}
    </>
  );
}

